var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPosicao1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 115,
    viewBox: "0 0 86 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 58.8418,
    width: 86,
    height: 56,
    fill: "url(#paint0_linear_342_28030)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5879 11.4322L30.9664 15.4098L25 3.97762L32.6214 0L38.5879 11.4322Z",
    fill: "#5C1526"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5976 12.9927L34.1475 13.7495L28.1811 2.31738L29.6312 1.56055L35.5976 12.9927Z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5879 11.4326L56.2093 15.4102L62.1758 3.97807L54.5543 0.000444412L48.5879 11.4326Z",
    fill: "#5C1526"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5781 12.9932L53.0283 13.75L58.9947 2.31782L57.5446 1.56099L51.5781 12.9932Z",
    fill: "#FEFEFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7455 28.8727C60.7455 38.7436 52.7436 46.7455 42.8727 46.7455C33.0019 46.7455 25 38.7436 25 28.8727C25 19.0019 33.0019 11 42.8727 11C52.7436 11 60.7455 19.0019 60.7455 28.8727Z",
    fill: "url(#paint1_linear_342_28030)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7455 28.8727C62.7455 39.8481 53.8481 48.7455 42.8727 48.7455C31.8973 48.7455 23 39.8481 23 28.8727C23 17.8973 31.8973 9 42.8727 9C53.8481 9 62.7455 17.8973 62.7455 28.8727ZM42.8727 46.7455C52.7436 46.7455 60.7455 38.7436 60.7455 28.8727C60.7455 19.0019 52.7436 11 42.8727 11C33.0019 11 25 19.0019 25 28.8727C25 38.7436 33.0019 46.7455 42.8727 46.7455Z",
    fill: "#9C6F30"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8727 44.7455C51.639 44.7455 58.7455 37.639 58.7455 28.8727C58.7455 20.1065 51.639 13 42.8727 13C34.1065 13 27 20.1065 27 28.8727C27 37.639 34.1065 44.7455 42.8727 44.7455ZM42.8727 46.7455C52.7436 46.7455 60.7455 38.7436 60.7455 28.8727C60.7455 19.0019 52.7436 11 42.8727 11C33.0019 11 25 19.0019 25 28.8727C25 38.7436 33.0019 46.7455 42.8727 46.7455Z",
    fill: "#F7C580"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1151 22.0811H43.7378V35.6641H41.2548V25.5782H40.0098V23.9905C40.7279 23.9252 41.2315 23.7317 41.5206 23.41C41.8097 23.0882 42.0078 22.6453 42.1151 22.0811Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_342_28030",
    x1: 43,
    y1: 58.8418,
    x2: 43,
    y2: 114.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D1E32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F1221"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_342_28030",
    x1: 42.8727,
    y1: 0,
    x2: 42.8727,
    y2: 48.7455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB012"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosicao1);
export default __webpack_public_path__ + "static/media/posicao-1.5d98ae7353d0e94c634dadbbf077a0fa.svg";
export { ForwardRef as ReactComponent };